import React, { useState } from "react"
import { setOutSideFormField } from './Helper'

interface Props {
  name: string,
  tag: string,
  value: string,
  iconClass: string,
  note: string,
}

const CheckboxField: React.FC<Props> = (props) => {
  const [value, setValue] = useState<boolean>(JSON.parse(props.value));

  const handleChange = (event: React.SyntheticEvent) => {
    const target = event.target as HTMLInputElement;
    setValue(target.checked);
    setOutSideFormField(props.tag ,target.checked.toString());
  }

  return (
    <div className="column-form">
      <div className="column-form-icon">
        <span className={props.iconClass + ' column-data-icon'}></span>
        <span className="column-data-icontext">{props.name}</span>
      </div>
      <div className="form-group">
        <div className="custom-control custom-switch">
          <input type="checkbox" checked={value} onChange={handleChange}　className="custom-control-input" id="canCoachRead" />
          <label className="custom-control-label" htmlFor="canCoachRead">{value ? '公開' : '非公開'}</label>
        </div>
        <div className="small text-muted">{props.note}</div>
      </div>
    </div>
  )
}

export default CheckboxField